import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getPayoutDetails, getPayoutList, getPayoutNotification } from './thunks/payoutListThunk';

const initialState = {
  isLoading: false,
  payoutData: [],
  payoutNotifCount: 0,
  payoutDetails: [],
};

const slice = createSlice({
  name: 'payout',
  initialState,
  reducers: {},
  extraReducers: {
    [getPayoutList.pending]: (state) => {
      state.isLoading = true;
    },
    [getPayoutList.fulfilled]: (state, action) => {
      state.payoutData = action.payload.data;
      /* let pendingCount = 0;
      for (let i = 0; i < action.payload.data.length; i++) {
        if (action.payload.data[i]?.attributes.payout_status === 'pending') {
          pendingCount++;
        }
      }
      state.payoutPendingCount = pendingCount; */
      state.isLoading = false;
    },
    [getPayoutList.rejected]: (state, action) => {
      console.log(action.payload);
      state.isLoading = false;
    },
    [getPayoutDetails.pending]: (state) => {
      state.isLoading = true;
    },
    [getPayoutDetails.fulfilled]: (state, action) => {
      state.payoutDetails = action.payload.data;
      state.isLoading = false;
    },
    [getPayoutDetails.rejected]: (state, action) => {
      console.log(action.payload);
      state.isLoading = false;
    },
    [getPayoutNotification.pending]: (state) => {
      state.isLoading = true;
    },
    [getPayoutNotification.fulfilled]: (state, action) => {
      state.payoutNotifCount = parseInt(action.payload.data[0].toString());
      state.isLoading = false;
    },
    [getPayoutNotification.rejected]: (state, action) => {
      console.log(action.payload);
      state.isLoading = false;
    },
  },
});

export const { actions: payoutActions, reducer: payoutReducer } = slice;

const selectDomain = (state) => state.payout || initialState;

export const selectPayout = createSelector([selectDomain], (payoutState) => payoutState);

export { getPayoutList, getPayoutNotification };
